import './columns.scss';

export default function decorate(block) {
  const cols = [...block.firstElementChild.children];
  block.classList.add(`columns-${cols.length}-cols`);

  // setup image columns
  [...block.children].forEach((row) => {
    [...row.children].forEach((col) => {
      const pic = col.querySelector('picture');
      if (pic) {
        const picWrapper = pic.closest('div');
        if (picWrapper && picWrapper.children.length === 1) {
          // picture is only content in column
          picWrapper.classList.add('columns-img-col');
        }
      }
    });
  });

  // SWS-1515 - focal point implementation
  const images = block.querySelectorAll('img');
  images.forEach((image) => {
    const { title } = image.dataset;
    if (title?.includes('data-focal')) {
      delete image.dataset.title;
      const [x, y] = title.split(':')[1].split(',');
      image.style.objectPosition = `${x}% ${y}%`;
    }
  });
}
